<template>
  <div class="table_btns" style="flex-wrap: nowrap">
    <v-tooltip
      v-if="canChangeChild && !$store.getters.isNurse"
      color="#fff"
      left
      nudge-right="10"
      nudge-top="35"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="new_style"
          @click="$emit('sendOrder')"
          :data-test="`omtkOrders-order-${itemIndex}-orderItem-${index}-sendOrder-btn`"
        >
          <vue-icon icon="newShareIcon"></vue-icon>
        </v-btn>
      </template>
      <span>{{ $t("sendToOzl") }}</span>
    </v-tooltip>
    <v-tooltip
      v-if="canChangeChild"
      color="#fff"
      left
      nudge-right="10"
      nudge-top="35"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="new_style"
          @click="$emit('editItem')"
          :data-test="`omtkOrders-order-${itemIndex}-orderItem-${index}-calculator-btn`"
        >
          <vue-icon icon="newCalcIcon"></vue-icon>
        </v-btn>
      </template>
      <span>{{ $t("productAvailableNotEnoughQuantity") }}</span>
    </v-tooltip>
    <v-tooltip
      v-if="
        productEnough &&
        $can($permissions['OMTK.APPROVE.ORDER']) &&
        canChangeChild
      "
      color="#fff"
      left
      nudge-right="10"
      nudge-top="35"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="new_style"
          @click="$emit('acceptOrderItem')"
          :data-test="`omtkOrders-order-${itemIndex}-orderItem-${index}-acceptOrder-btn`"
        >
          <vue-icon icon="newCheckIcon"></vue-icon>
        </v-btn>
      </template>
      <span>{{ $t("approveRequest") }}</span>
    </v-tooltip>
    <v-tooltip
      v-if="canChangeChild"
      color="#fff"
      left
      nudge-right="10"
      nudge-top="35"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="new_style error"
          @click="$emit('rejectOrderConfirmHandler')"
          :data-test="`omtkOrders-order-${itemIndex}-orderItem-${index}-cancel-btn`"
        >
          <vue-icon icon="newCancelIcon"></vue-icon>
        </v-btn>
      </template>
      <span>{{ $t("rejectRequest") }}</span>
    </v-tooltip>
    <v-btn
      v-if="child.contractNumber && $can($permissions['OMTK.SEND.ORDER'])"
      @click="$emit('openReception', child.id)"
      :class="trueSet(child.seenInitiatorNotification) ? 'success' : 'error'"
      class="new_style"
      :data-test="`omtkOrders-order-${itemIndex}-orderItem-${index}-bell-btn`"
    >
      <vue-icon icon="bellIcon" />
    </v-btn>
    <!--    <v-btn-->
    <!--      @click="$emit('FINISH_ORDER_ITEM', child)"-->
    <!--      v-if="child.state !== orderItemStatus.RECEIVED"-->
    <!--      :class="[-->
    <!--        'new_style',-->
    <!--        child.state === orderItemStatus.COMPLETED ? 'success' : 'error',-->
    <!--      ]"-->
    <!--      :data-test="`omtkOrders-order-${itemIndex}-orderItem-${index}-finish-btn`"-->
    <!--    >-->
    <!--      <vue-icon icon="newFlagIcon" />-->
    <!--    </v-btn>-->
  </div>
</template>

<script>
import { orderItemStatus } from "@/utils/constants";
import { trueSet } from "@/utils/pureFunctions";

export default {
  name: "order-table-child-action",
  props: {
    item: { type: Object },
    child: { type: Object },
    itemIndex: { type: Number },
    index: { type: Number },
    productEnough: {
      type: Boolean,
    },
  },
  emits: ["FINISH_ORDER_ITEM"],
  computed: {
    trueSet: () => trueSet,
    orderItemStatus: () => orderItemStatus,
    canChangeChild() {
      const { state } = this.child;
      return state ? state === orderItemStatus.TO_REVIEW_WAREHOUSE : false;
    },
    hasProduct() {
      return this.child.hasProductCount
        ? parseFloat(this.child.hasProductCount) > 0
        : false;
    },
  },
};
</script>
